// package: clientconfig
// file: clientconfig/service.proto

import * as clientconfig_model from "../clientconfig/model";
import * as common_app from "../common/app";
import * as common_method_options from "../common/method_options";
import * as common_service_options from "../common/service_options";
import * as common_platform from "../common/platform";
import * as common_user from "../common/user";
import * as common_version from "../common/version";

import { interfaceAPI } from "../sdk/api";
import { createFetcher, CacheMode } from "create-fetcher";
import { defaultCache } from "../sdk/fetcher";

export const GetVersionConfigRequest = {
    encode(object) {
        const message = {};
        if (object.platform != null) {
            if (object.platform !== 0) {
                message.platform = object.platform;
            }
        }
        if (object.version != null) {
            if (object.version !== "") {
                message.version = String(object.version);
            }
        }
        if (object.channel != null) {
            if (object.channel !== "") {
                message.channel = String(object.channel);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            platform: 0,
            version: "",
            channel: "",
        };

        if (message.platform != null) {
            object.platform = message.platform;
        }
        if (message.version != null) {
            object.version = message.version;
        }
        if (message.channel != null) {
            object.channel = message.channel;
        }
        return object;
    },
};

export const GetVersionConfigReply = {
    encode(object) {
        const message = {};
        if (object.versionConfig != null) {
            message.versionConfig = clientconfig_model.VersionConfig.encode(object.versionConfig);
        }
        if (object.beginTime != null) {
            if (object.beginTime !== 0) {
                message.beginTime = String(object.beginTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            versionConfig: null,
            beginTime: 0,
        };

        if (message.versionConfig != null) {
            object.versionConfig = clientconfig_model.VersionConfig.decode(message.versionConfig);
        }
        if (message.beginTime != null) {
            object.beginTime = parseInt(message.beginTime, 10);
        }
        return object;
    },
};

export const GetWebScreensConfigRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const GetWebScreensConfigReply = {
    encode(object) {
        const message = {};
        if (object.pathVersionList != null) {
            if (!Array.isArray(object.pathVersionList)) {
                throw TypeError("pathVersionList: array expected");
            }
            if (object.pathVersionList.length > 0) {
                message.pathVersionList = [];
                for (let i = 0; i < object.pathVersionList.length; ++i) {
                    message.pathVersionList[i] = clientconfig_model.PathVersion.encode(object.pathVersionList[i]);
                }
            }
        }
        if (object.whitelistHostList != null) {
            if (!Array.isArray(object.whitelistHostList)) {
                throw TypeError("whitelistHostList: array expected");
            }
            if (object.whitelistHostList.length > 0) {
                message.whitelistHostList = [];
                for (let i = 0; i < object.whitelistHostList.length; ++i) {
                    message.whitelistHostList[i] = String(object.whitelistHostList[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            pathVersionList: [],
            whitelistHostList: [],
        };

        if (message.pathVersionList != null) {
            object.pathVersionList = [];
            for (let i = 0; i < message.pathVersionList.length; ++i) {
                object.pathVersionList[i] = clientconfig_model.PathVersion.decode(message.pathVersionList[i]);
            }
        }
        if (message.whitelistHostList != null) {
            object.whitelistHostList = [];
            for (let i = 0; i < message.whitelistHostList.length; ++i) {
                    object.whitelistHostList[i] = message.whitelistHostList[i];
            }
        }
        return object;
    },
};

export const UpdateScreenPathVersionRequest = {
    encode(object) {
        const message = {};
        if (object.token != null) {
            if (object.token !== "") {
                message.token = String(object.token);
            }
        }
        if (object.pathVersionJson != null) {
            if (object.pathVersionJson !== "") {
                message.pathVersionJson = String(object.pathVersionJson);
            }
        }
        if (object.screenType != null) {
            if (object.screenType !== 0) {
                message.screenType = object.screenType;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            token: "",
            pathVersionJson: "",
            screenType: 0,
        };

        if (message.token != null) {
            object.token = message.token;
        }
        if (message.pathVersionJson != null) {
            object.pathVersionJson = message.pathVersionJson;
        }
        if (message.screenType != null) {
            object.screenType = message.screenType;
        }
        return object;
    },
};

export const UpdateScreenPathVersionReply = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ListWechatShareConfigRequest = {
    encode(object) {
        const message = {};
        if (object.shareType != null) {
            if (object.shareType !== "") {
                message.shareType = String(object.shareType);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            shareType: "",
        };

        if (message.shareType != null) {
            object.shareType = message.shareType;
        }
        return object;
    },
};

export const ListWechatShareConfigReply = {
    encode(object) {
        const message = {};
        if (object.wechatShareConfigList != null) {
            if (!Array.isArray(object.wechatShareConfigList)) {
                throw TypeError("wechatShareConfigList: array expected");
            }
            if (object.wechatShareConfigList.length > 0) {
                message.wechatShareConfigList = [];
                for (let i = 0; i < object.wechatShareConfigList.length; ++i) {
                    message.wechatShareConfigList[i] = clientconfig_model.WechatShareConfig.encode(object.wechatShareConfigList[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            wechatShareConfigList: [],
        };

        if (message.wechatShareConfigList != null) {
            object.wechatShareConfigList = [];
            for (let i = 0; i < message.wechatShareConfigList.length; ++i) {
                object.wechatShareConfigList[i] = clientconfig_model.WechatShareConfig.decode(message.wechatShareConfigList[i]);
            }
        }
        return object;
    },
};

export const ListNoticeRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ListNoticeReply = {
    encode(object) {
        const message = {};
        if (object.list != null) {
            if (!Array.isArray(object.list)) {
                throw TypeError("list: array expected");
            }
            if (object.list.length > 0) {
                message.list = [];
                for (let i = 0; i < object.list.length; ++i) {
                    message.list[i] = clientconfig_model.Notice.encode(object.list[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            list: [],
        };

        if (message.list != null) {
            object.list = [];
            for (let i = 0; i < message.list.length; ++i) {
                object.list[i] = clientconfig_model.Notice.decode(message.list[i]);
            }
        }
        return object;
    },
};

export const ListBannerRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ListBannerReply = {
    encode(object) {
        const message = {};
        if (object.list != null) {
            if (!Array.isArray(object.list)) {
                throw TypeError("list: array expected");
            }
            if (object.list.length > 0) {
                message.list = [];
                for (let i = 0; i < object.list.length; ++i) {
                    message.list[i] = clientconfig_model.Banner.encode(object.list[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            list: [],
        };

        if (message.list != null) {
            object.list = [];
            for (let i = 0; i < message.list.length; ++i) {
                object.list[i] = clientconfig_model.Banner.decode(message.list[i]);
            }
        }
        return object;
    },
};

export const ListNewsRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ListNewsReply = {
    encode(object) {
        const message = {};
        if (object.lists != null) {
            if (!Array.isArray(object.lists)) {
                throw TypeError("lists: array expected");
            }
            if (object.lists.length > 0) {
                message.lists = [];
                for (let i = 0; i < object.lists.length; ++i) {
                    message.lists[i] = clientconfig_model.NewsList.encode(object.lists[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            lists: [],
        };

        if (message.lists != null) {
            object.lists = [];
            for (let i = 0; i < message.lists.length; ++i) {
                object.lists[i] = clientconfig_model.NewsList.decode(message.lists[i]);
            }
        }
        return object;
    },
};

export const ListRandomRobotsRequest = {
    encode(object) {
        const message = {};
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = String(object.count);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            count: 0,
        };

        if (message.count != null) {
            object.count = parseInt(message.count, 10);
        }
        return object;
    },
};

export const ListRandomRobotsReply = {
    encode(object) {
        const message = {};
        if (object.lists != null) {
            if (!Array.isArray(object.lists)) {
                throw TypeError("lists: array expected");
            }
            if (object.lists.length > 0) {
                message.lists = [];
                for (let i = 0; i < object.lists.length; ++i) {
                    message.lists[i] = clientconfig_model.NewsListV2.encode(object.lists[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            lists: [],
        };

        if (message.lists != null) {
            object.lists = [];
            for (let i = 0; i < message.lists.length; ++i) {
                object.lists[i] = clientconfig_model.NewsListV2.decode(message.lists[i]);
            }
        }
        return object;
    },
};

export const ListBuyNewsRequest = {
    encode(object) {
        const message = {};
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = String(object.count);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            count: 0,
        };

        if (message.count != null) {
            object.count = parseInt(message.count, 10);
        }
        return object;
    },
};

export const ListBuyNewsReply = {
    encode(object) {
        const message = {};
        if (object.lists != null) {
            if (!Array.isArray(object.lists)) {
                throw TypeError("lists: array expected");
            }
            if (object.lists.length > 0) {
                message.lists = [];
                for (let i = 0; i < object.lists.length; ++i) {
                    message.lists[i] = clientconfig_model.NewsListV2.encode(object.lists[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            lists: [],
        };

        if (message.lists != null) {
            object.lists = [];
            for (let i = 0; i < message.lists.length; ++i) {
                object.lists[i] = clientconfig_model.NewsListV2.decode(message.lists[i]);
            }
        }
        return object;
    },
};

export const ListSaveMoneyCardFreeBuyCommentsRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const ListSaveMoneyCardFreeBuyCommentsReply = {
    encode(object) {
        const message = {};
        if (object.comments != null) {
            if (!Array.isArray(object.comments)) {
                throw TypeError("comments: array expected");
            }
            if (object.comments.length > 0) {
                message.comments = [];
                for (let i = 0; i < object.comments.length; ++i) {
                    message.comments[i] = clientconfig_model.SaveMoneyCardFreeBuyComment.encode(object.comments[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            comments: [],
        };

        if (message.comments != null) {
            object.comments = [];
            for (let i = 0; i < message.comments.length; ++i) {
                object.comments[i] = clientconfig_model.SaveMoneyCardFreeBuyComment.decode(message.comments[i]);
            }
        }
        return object;
    },
};

export const ListUsersRequest = {
    encode(object) {
        const message = {};
        if (object.count != null) {
            if (object.count !== 0) {
                message.count = String(object.count);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            count: 0,
        };

        if (message.count != null) {
            object.count = parseInt(message.count, 10);
        }
        return object;
    },
};

export const ListUsersReply = {
    encode(object) {
        const message = {};
        if (object.users != null) {
            if (!Array.isArray(object.users)) {
                throw TypeError("users: array expected");
            }
            if (object.users.length > 0) {
                message.users = [];
                for (let i = 0; i < object.users.length; ++i) {
                    message.users[i] = common_user.User.encode(object.users[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            users: [],
        };

        if (message.users != null) {
            object.users = [];
            for (let i = 0; i < message.users.length; ++i) {
                object.users[i] = common_user.User.decode(message.users[i]);
            }
        }
        return object;
    },
};

export const GetVersionConfigV2Request = {
    encode(object) {
        const message = {};
        if (object.platform != null) {
            if (object.platform !== 0) {
                message.platform = object.platform;
            }
        }
        if (object.version != null) {
            if (object.version !== "") {
                message.version = String(object.version);
            }
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            platform: 0,
            version: "",
            app: 0,
        };

        if (message.platform != null) {
            object.platform = message.platform;
        }
        if (message.version != null) {
            object.version = message.version;
        }
        if (message.app != null) {
            object.app = message.app;
        }
        return object;
    },
};

export const GetVersionConfigV2Reply = {
    encode(object) {
        const message = {};
        if (object.versionConfig != null) {
            message.versionConfig = clientconfig_model.VersionConfig.encode(object.versionConfig);
        }
        if (object.privacyPolicyVersion != null) {
            if (object.privacyPolicyVersion !== "") {
                message.privacyPolicyVersion = String(object.privacyPolicyVersion);
            }
        }
        if (object.minAcceptedPrivacyPolicyVersion != null) {
            if (object.minAcceptedPrivacyPolicyVersion !== "") {
                message.minAcceptedPrivacyPolicyVersion = String(object.minAcceptedPrivacyPolicyVersion);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            versionConfig: null,
            privacyPolicyVersion: "",
            minAcceptedPrivacyPolicyVersion: "",
        };

        if (message.versionConfig != null) {
            object.versionConfig = clientconfig_model.VersionConfig.decode(message.versionConfig);
        }
        if (message.privacyPolicyVersion != null) {
            object.privacyPolicyVersion = message.privacyPolicyVersion;
        }
        if (message.minAcceptedPrivacyPolicyVersion != null) {
            object.minAcceptedPrivacyPolicyVersion = message.minAcceptedPrivacyPolicyVersion;
        }
        return object;
    },
};

export const GetScreenshotConfigRequest = {
    encode(object) {
        const message = {};
        return message;
    },

    decode(message) {
        const object = {
        };

        return object;
    },
};

export const GetScreenshotConfigReply = {
    encode(object) {
        const message = {};
        if (object.paths != null) {
            if (!Array.isArray(object.paths)) {
                throw TypeError("paths: array expected");
            }
            if (object.paths.length > 0) {
                message.paths = [];
                for (let i = 0; i < object.paths.length; ++i) {
                    message.paths[i] = String(object.paths[i]);
                }
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            paths: [],
        };

        if (message.paths != null) {
            object.paths = [];
            for (let i = 0; i < message.paths.length; ++i) {
                    object.paths[i] = message.paths[i];
            }
        }
        return object;
    },
};

export const GetVersionConfigV3Request = {
    encode(object) {
        const message = {};
        if (object.platform != null) {
            if (object.platform !== 0) {
                message.platform = object.platform;
            }
        }
        if (object.app != null) {
            if (object.app !== 0) {
                message.app = object.app;
            }
        }
        if (object.channel != null) {
            if (object.channel !== "") {
                message.channel = String(object.channel);
            }
        }
        if (object.version != null) {
            message.version = common_version.Version.encode(object.version);
        }
        return message;
    },

    decode(message) {
        const object = {
            platform: 0,
            app: 0,
            channel: "",
            version: null,
        };

        if (message.platform != null) {
            object.platform = message.platform;
        }
        if (message.app != null) {
            object.app = message.app;
        }
        if (message.channel != null) {
            object.channel = message.channel;
        }
        if (message.version != null) {
            object.version = common_version.Version.decode(message.version);
        }
        return object;
    },
};

export const GetVersionConfigV3Reply = {
    encode(object) {
        const message = {};
        if (object.versionConfig != null) {
            message.versionConfig = clientconfig_model.VersionConfig.encode(object.versionConfig);
        }
        if (object.privacyPolicyVersion != null) {
            if (object.privacyPolicyVersion !== "") {
                message.privacyPolicyVersion = String(object.privacyPolicyVersion);
            }
        }
        if (object.minAcceptedPrivacyPolicyVersion != null) {
            if (object.minAcceptedPrivacyPolicyVersion !== "") {
                message.minAcceptedPrivacyPolicyVersion = String(object.minAcceptedPrivacyPolicyVersion);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            versionConfig: null,
            privacyPolicyVersion: "",
            minAcceptedPrivacyPolicyVersion: "",
        };

        if (message.versionConfig != null) {
            object.versionConfig = clientconfig_model.VersionConfig.decode(message.versionConfig);
        }
        if (message.privacyPolicyVersion != null) {
            object.privacyPolicyVersion = message.privacyPolicyVersion;
        }
        if (message.minAcceptedPrivacyPolicyVersion != null) {
            object.minAcceptedPrivacyPolicyVersion = message.minAcceptedPrivacyPolicyVersion;
        }
        return object;
    },
};

export function GetVersionConfig(request, options) {
    return interfaceAPI("/clientconfig.Default/GetVersionConfig", GetVersionConfigRequest.encode(request), GetVersionConfigReply, Object.assign({ isAuthFree: 1, }, options));
}
export const GetVersionConfigFetcher = createFetcher(GetVersionConfig, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/GetVersionConfig:", cacheMinFresh: 60, cacheMaxAge: 604800 });

export function GetWebScreensConfig(request, options) {
    return interfaceAPI("/clientconfig.Default/GetWebScreensConfig", GetWebScreensConfigRequest.encode(request), GetWebScreensConfigReply, Object.assign({ isAuthFree: 1, }, options));
}
export const GetWebScreensConfigFetcher = createFetcher(GetWebScreensConfig, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/GetWebScreensConfig:", cacheMinFresh: 600, cacheMaxAge: 86400 });

export function UpdateScreenPathVersion(request, options) {
    return interfaceAPI("/clientconfig.Default/UpdateScreenPathVersion", UpdateScreenPathVersionRequest.encode(request), UpdateScreenPathVersionReply, Object.assign({ isAuthFree: 1, }, options));
}

export function ListWechatShareConfig(request, options) {
    return interfaceAPI("/clientconfig.Default/ListWechatShareConfig", ListWechatShareConfigRequest.encode(request), ListWechatShareConfigReply, Object.assign({ isAuthFree: 1, }, options));
}
export const ListWechatShareConfigFetcher = createFetcher(ListWechatShareConfig, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListWechatShareConfig:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function ListNotice(request, options) {
    return interfaceAPI("/clientconfig.Default/ListNotice", ListNoticeRequest.encode(request), ListNoticeReply, Object.assign({ isAuthFree: 1, }, options));
}
export const ListNoticeFetcher = createFetcher(ListNotice, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListNotice:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function ListBanner(request, options) {
    return interfaceAPI("/clientconfig.Default/ListBanner", ListBannerRequest.encode(request), ListBannerReply, Object.assign({ isAuthFree: 1, }, options));
}
export const ListBannerFetcher = createFetcher(ListBanner, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListBanner:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function ListNews(request, options) {
    return interfaceAPI("/clientconfig.Default/ListNews", ListNewsRequest.encode(request), ListNewsReply, Object.assign({ isAuthFree: 1, }, options));
}
export const ListNewsFetcher = createFetcher(ListNews, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListNews:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function ListRandomRobots(request, options) {
    return interfaceAPI("/clientconfig.Default/ListRandomRobots", ListRandomRobotsRequest.encode(request), ListRandomRobotsReply, Object.assign({ isAuthFree: 1, }, options));
}
export const ListRandomRobotsFetcher = createFetcher(ListRandomRobots, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListRandomRobots:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function ListBuyNews(request, options) {
    return interfaceAPI("/clientconfig.Default/ListBuyNews", ListBuyNewsRequest.encode(request), ListBuyNewsReply, Object.assign({ isAuthFree: 1, }, options));
}
export const ListBuyNewsFetcher = createFetcher(ListBuyNews, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListBuyNews:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function ListSaveMoneyCardFreeBuyComments(request, options) {
    return interfaceAPI("/clientconfig.Default/ListSaveMoneyCardFreeBuyComments", ListSaveMoneyCardFreeBuyCommentsRequest.encode(request), ListSaveMoneyCardFreeBuyCommentsReply, options);
}
export const ListSaveMoneyCardFreeBuyCommentsFetcher = createFetcher(ListSaveMoneyCardFreeBuyComments, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListSaveMoneyCardFreeBuyComments:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function ListUsers(request, options) {
    return interfaceAPI("/clientconfig.Default/ListUsers", ListUsersRequest.encode(request), ListUsersReply, Object.assign({ isAuthFree: 1, }, options));
}
export const ListUsersFetcher = createFetcher(ListUsers, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/ListUsers:", cacheMinFresh: 60, cacheMaxAge: 86400 });

export function GetVersionConfigV2(request, options) {
    return interfaceAPI("/clientconfig.Default/GetVersionConfigV2", GetVersionConfigV2Request.encode(request), GetVersionConfigV2Reply, Object.assign({ isAuthFree: 1, }, options));
}
export const GetVersionConfigV2Fetcher = createFetcher(GetVersionConfigV2, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/GetVersionConfigV2:", cacheMinFresh: 60, cacheMaxAge: 604800 });

export function GetScreenshotConfig(request, options) {
    return interfaceAPI("/clientconfig.Default/GetScreenshotConfig", GetScreenshotConfigRequest.encode(request), GetScreenshotConfigReply, Object.assign({ isAuthFree: 1, }, options));
}
export const GetScreenshotConfigFetcher = createFetcher(GetScreenshotConfig, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/GetScreenshotConfig:", cacheMinFresh: 60, cacheMaxAge: 604800 });

export function GetVersionConfigV3(request, options) {
    return interfaceAPI("/clientconfig.Default/GetVersionConfigV3", GetVersionConfigV3Request.encode(request), GetVersionConfigV3Reply, Object.assign({ isAuthFree: 1, }, options));
}
export const GetVersionConfigV3Fetcher = createFetcher(GetVersionConfigV3, { cache: defaultCache, cacheMode: CacheMode.Default, cacheKeyPrefix: "/clientconfig.Default/GetVersionConfigV3:", cacheMinFresh: 60, cacheMaxAge: 604800 });


